import type { ReactNode } from 'react';
import { Disclosure } from 'react-aria-components';
import { Checkbox } from '@/components/Checkbox';
import * as Styled from './CheckboxDisclosure.styled';

// We need both isExpanded and isSelected because sometimes
// the disclosure is expanded when checkbox is selected
// but sometimes it's the opposite.
interface CheckboxDisclosureProps {
  children: ReactNode;
  className?: string;
  handleClick: () => void;
  isExpanded: boolean;
  isSelected: boolean;
  label: string;
  name?: string;
}

export const CheckboxDisclosure = ({
  children,
  className,
  handleClick,
  isExpanded,
  isSelected,
  label,
  name,
}: CheckboxDisclosureProps) => (
  <Disclosure
    className={className}
    data-validation-key={name}
    isExpanded={isExpanded}
  >
    <Checkbox
      label={label}
      onChange={handleClick}
      slot="trigger"
      isSelected={isSelected}
    />
    <Styled.Panel>{children}</Styled.Panel>
  </Disclosure>
);
